import React, { useState } from 'react';

import BoxBody from 'components/BoxBody';
import CoachingConstants from 'coaching/CoachingConstants';
import FormElement from 'components/FormElement';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import Row from 'components/Row';
import Select from 'components/Select';
import Text from 'components/Text';
import Textarea from 'components/Textarea';

import { getCoachTitle } from 'coaching/lib/nameFormat';

export type Props = {
  onSelectCancellationReason?: (
    cancellationReason: CoachingSessionScheduleCancellationReasons
  ) => void;
  wouldBeLateCancellation?: boolean;
  coachName?: string;
};

export type CoachingSessionScheduleCancellationReasons =
  | 'achieved_goal'
  | 'too_expensive'
  | 'end_of_term'
  | 'other_reason';

export default function CancelRecurringSession({
  onSelectCancellationReason,
  wouldBeLateCancellation,
  coachName,
}: Props) {
  if (wouldBeLateCancellation) {
    return (
      <div data-test="late-cancellation-notice">
        <BoxBody size="xsmall">
          <Text size="xsmall">
            Your future sessions with {coachName ? getCoachTitle(coachName) : 'your coach'} will be
            cancelled.
          </Text>
        </BoxBody>
        <BoxBody size="xsmall" margin="small" dark rounded>
          <Row size="small">
            <Text>
              You have a session that starts within 24 hours. You will be charged for the full
              session amount.
            </Text>
          </Row>
          <Link weight="semibold" href={LinkConstants.COACHING_HELP_SCHEDULING} target="_blank">
            View our scheduling policy
          </Link>
        </BoxBody>
      </div>
    );
  }

  const [cancellationReason, setCancellationReason] = useState<
    CoachingSessionScheduleCancellationReasons
  >();
  const [details, setDetails] = useState<string | undefined>(undefined);

  const cancellationReasonLabel = 'Reason for cancelling';
  const detailsLabel = (
    <Text>
      Tell us more <Text weight="normal">(Optional)</Text>
    </Text>
  );

  return (
    <>
      <BoxBody size="xsmall" flush>
        <FormElement
          data-test="cancellation-reason-select"
          label={cancellationReasonLabel}
          element={Select}
          onValidChange={value => {
            setCancellationReason(value);
            onSelectCancellationReason?.(value);
          }}
          elementProps={{
            searchable: false,
            name: 'cancellationReason',
            value: cancellationReason,
            options: CoachingConstants.SELF_SERVE_SCHEDULE_CANCELLATION_REASONS,
          }}
        />
        {cancellationReason && (
          <FormElement
            data-test="cancellation-details-textarea"
            label={detailsLabel}
            element={Textarea}
            elementProps={{
              value: details,
              placeholder: 'Enter text',
            }}
            onValidChange={e => setDetails(e.target.value)}
          />
        )}
      </BoxBody>
    </>
  );
}
